const ERROR_MESSAGES = {
  SERVER_ERROR: 'Ошибка сервера. Попробуйте повторить позже',
  UNAUTHORIZED_REQUEST: 'Вы не авторизованы',
};

export default ERROR_MESSAGES;
